import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Icon from "@mui/material/Icon";
import NewNearMiss from "layouts/newNearMiss";
import Relatorios from "layouts/relatorios/relatorios";
import BestNM from "layouts/bestNM/bestNM";
import MobileHome from "layouts/mobileHome";
import { getLayoutByDevice } from "hooks/mobileCheck/useCheckMobile";

// Verifica se é PC (verticalLayout = true)
const isMobile = getLayoutByDevice();

const allRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Reportar",
    key: "reportar",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/reportar",
    component: <NewNearMiss />,
  },
  {
    type: "collapse",
    name: "Registos",
    key: "registos",
    icon: <Icon fontSize="small">list_alt</Icon>,
    route: "/registos",
    component: <Tables />,
  },
  {
    type: "collapse",
    name: "Relatórios",
    key: "relatorios",
    icon: <Icon fontSize="small">assessment</Icon>,
    route: "/relatorios",
    component: <Relatorios />,
  },
  {
    type: "collapse",
    name: "Best near miss",
    key: "bestnm",
    icon: <i className="fa-solid fa-star"></i>,
    route: "/bestnm",
    component: <BestNM />,
  }
];

// Se for Mobile (isMobile = true), retorna a rota "Home Mobile" e "Reportar"
// Se for PC (isMobile = false), retorna todas as rotas padrão
const routes = isMobile 
  ? [
      {
        type: "collapse",
        name: "Home Mobile",
        key: "mobile-home",
        icon: <Icon fontSize="small">home</Icon>,
        route: "/mobile-home",
        component: <MobileHome />,
      },
      ...allRoutes.filter(route => route.key === "reportar")
    ]
  : allRoutes;

export default routes;